import { useDispatch, useSelector } from "react-redux";
import { toggleSidebarFalse, toggleSidebarTrue } from "../../redux/slices/sidebarStatus";
import { FaHome, FaInfoCircle, FaProductHunt, FaBullhorn, FaGavel, FaBriefcase, FaNewspaper, FaFileContract, FaVideo, FaImage } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
import { LazyLoadImage } from "react-lazy-load-image-component";
import logoImg from "../../assets/img/logo/logobprblack.png";
import { useEffect, useState } from "react";
import { RiCalculatorFill, RiContactsBook2Fill, RiCustomerService2Fill, RiFile2Fill, RiShieldCheckFill } from "react-icons/ri";
import ReportModal from "./ReportModal";

export function Sidebar() {
    const dispatch = useDispatch();
    const isOpenSidebar = useSelector((state: any) => state.sidebarStatus.isOpen);
    const location = useLocation();

    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleSidebar = () => {
        if (isOpenSidebar) {
            dispatch(toggleSidebarFalse());
        } else {
            dispatch(toggleSidebarTrue());
        }
    };

    const handleOpenModal = () => setIsModalOpen(true);
    const handleCloseModal = () => setIsModalOpen(false);

    useEffect(() => {
        if (isOpenSidebar) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpenSidebar]);

    useEffect(() => {
        dispatch(toggleSidebarFalse());
    }, [location, dispatch]);

    return (
        <>
            <div className={`${isOpenSidebar ? "translate-x-0" : "-translate-x-full"} fixed z-50 top-0 left-0 h-full w-64 bg-white dark:bg-slate-800 p-4 transform transition-transform overflow-y-auto max-h-screen`}>
                <div className="flex justify-center mb-4 border-b-2 p-2">
                    <LazyLoadImage
                        src={logoImg}
                        alt="logo"
                        width="190"
                        height="87"
                        effect="blur"
                        wrapperProps={{
                            style: { transitionDelay: "1s" },
                        }}
                    >
                    </LazyLoadImage>
                    {/* <button onClick={handleSidebar} className="text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-gray-500 text-lg">
                        x
                    </button> */}
                </div>

                <ul className="space-y-4">
                    <li className="flex items-center space-x-3 hover:bg-gray-200 dark:hover:bg-slate-800 rounded-lg">
                        <Link to="/" className="flex items-center space-x-3 p-2">
                            <FaHome className="text-bprDarkBlue" />
                            <span>Home</span>
                        </Link>
                    </li>
                    <li className="flex items-center space-x-3 hover:bg-gray-200 dark:hover:bg-slate-800 rounded-lg">
                        <Link to="/tentang-kami" className="flex items-center space-x-3 p-2">
                            <FaInfoCircle className="text-bprDarkBlue" />
                            <span>Tentang Kami</span>
                        </Link>
                    </li>
                    <li className="flex items-center space-x-3 hover:bg-gray-200 dark:hover:bg-slate-800 rounded-lg">
                        <Link to="/produk" className="flex items-center space-x-3 p-2">
                            <FaProductHunt className="text-bprDarkBlue" />
                            <span>Produk</span>
                        </Link>
                    </li>
                    <li className="flex items-center space-x-3 hover:bg-gray-200 dark:hover:bg-slate-800 rounded-lg">
                        <Link to="/penawaran-terkini" className="flex items-center space-x-3 p-2">
                            <FaBullhorn className="text-bprDarkBlue" />
                            <span>Penawaran Terkini</span>
                        </Link>
                    </li>
                    <li className="flex items-center space-x-3 hover:bg-gray-200 dark:hover:bg-slate-800 rounded-lg">
                        <Link to="/informasi-dan-berita" className="flex items-center space-x-3 p-2">
                            <FaNewspaper className="text-bprDarkBlue" />
                            <span>Informasi & Berita</span>
                        </Link>
                    </li>
                    <li className="flex items-center space-x-3 hover:bg-gray-200 dark:hover:bg-slate-800 rounded-lg">
                        <Link to="/lelang" className="flex items-center space-x-3 p-2">
                            <FaGavel className="text-bprDarkBlue" />
                            <span>Lelang</span>
                        </Link>
                    </li>
                    <li className="flex items-center space-x-3 hover:bg-gray-200 dark:hover:bg-slate-800 rounded-lg">
                        <Link to="/karir" className="flex items-center space-x-3 p-2">
                            <FaBriefcase className="text-bprDarkBlue" />
                            <span>Karir</span>
                        </Link>
                    </li>
                    <li className="flex items-center space-x-3 hover:bg-gray-200 dark:hover:bg-slate-800 rounded-lg">
                        <Link to="/#simulation" className="flex items-center space-x-3 p-2">
                            <RiCalculatorFill className="text-bprDarkBlue" />
                            <span>Simulasi</span>
                        </Link>
                    </li>
                    <li className="flex items-center space-x-3 hover:bg-gray-200 dark:hover:bg-slate-800 rounded-lg">
                        <Link to="/#contact" className="flex items-center space-x-3 p-2">
                            <RiContactsBook2Fill className="text-bprDarkBlue" />
                            <span>Kontak</span>
                        </Link>
                    </li>
                    <li className="flex items-center space-x-3 hover:bg-gray-200 dark:hover:bg-slate-800 rounded-lg">
                        <Link to="/pengaduan" className="flex items-center space-x-3 p-2">
                            <RiCustomerService2Fill className="text-bprDarkBlue" />
                            <span>Laporkan Masalah</span>
                        </Link>
                    </li>
                    <li className="flex items-center space-x-3 hover:bg-gray-200 dark:hover:bg-slate-800 rounded-lg">
                        <Link to="/dokumen/laporan-publikasi" className="flex items-center space-x-3 p-2">
                            <RiFile2Fill className="text-bprDarkBlue" />
                            <span>Laporan</span>
                        </Link>
                    </li>
                    <li className="flex items-center space-x-3 hover:bg-gray-200 dark:hover:bg-slate-800 rounded-lg">
                        <Link to="/dokumen/kebijakan-keamanan-informasi" className="flex items-center space-x-3 p-2">
                            <RiShieldCheckFill className="text-bprDarkBlue" />
                            <span>Kebijakan Keamanan Informasi</span>
                        </Link>
                    </li>
                    <li className="flex items-center space-x-3 hover:bg-gray-200 dark:hover:bg-slate-800 rounded-lg">
                        <Link to="/dokumen/dokumen-lainnya" className="flex items-center space-x-3 p-2">
                            <RiShieldCheckFill className="text-bprDarkBlue" />
                            <span>Dokumen Lainnya</span>
                        </Link>
                    </li>

                    <li className="flex items-center space-x-3 hover:bg-gray-200 dark:hover:bg-slate-800 rounded-lg">
                        <Link to="/galeri" className="flex items-center space-x-3 p-2">
                            <FaImage className="text-bprDarkBlue" />
                            <span>Galeri</span>
                        </Link>
                    </li>
                    <li className="flex items-center space-x-3 hover:bg-gray-200 dark:hover:bg-slate-800 rounded-lg">
                        <Link to="/media-edukasi" className="flex items-center space-x-3 p-2">
                            <FaVideo className="text-bprDarkBlue" />
                            <span>Media Edukasi</span>
                        </Link>
                    </li>
                </ul>
            </div>

            {isOpenSidebar && (
                <div onClick={handleSidebar} className="fixed inset-0 z-[31] bg-black opacity-50"></div>
            )}

            <ReportModal isOpen={isModalOpen} onClose={handleCloseModal} />
        </>
    );
}
